<template>
  <div class="col-auto d-flex flex-column gap-1">
    <!-- Profile -->
    <RouterLink :to="profileTo" :disabled="false">
      <button class="btn btn-white d-flex align-items-center py-50 pl-0">
        <div
          style="width: 36px; height: 36px;"
          :class="isProfileActive
            ? 'd-flex align-items-center justify-content-center rounded mr-75 bg-primary text-white'
            : 'd-flex align-items-center justify-content-center rounded mr-75 border text-secondary'"
        >
          1
        </div>
        <span :class="isProfileActive ? 'font-weight-bolder text-primary' : 'font-weight-bolder'">Profile</span>
      </button>
    </RouterLink>

    <!-- Address -->
    <component :is="brandId ? 'RouterLink' : 'div'" :to="brandId && `/v2/brands/${brandId}/address`">
      <button class="btn btn-white d-flex align-items-center py-50 pl-0" :disabled="!brandId">
        <div
          style="width: 36px; height: 36px;"
          :class="isAddressActive
            ? 'd-flex align-items-center justify-content-center rounded mr-75 bg-primary text-white'
            : 'd-flex align-items-center justify-content-center rounded mr-75 border text-secondary'"
        >
          2
        </div>
        <span :class="isAddressActive ? 'font-weight-bolder text-primary' : 'font-weight-bolder'">Alamat</span>
      </button>
    </component>

    <!-- Couriers -->
    <component :is="brandId ? 'RouterLink' : 'div'" :to="brandId && `/v2/brands/${brandId}/couriers`">
      <button class="btn btn-white d-flex align-items-center py-50 pl-0" :disabled="!brandId">
        <div
          style="width: 36px; height: 36px;"
          :class="isCouriersActive
            ? 'd-flex align-items-center justify-content-center rounded mr-75 bg-primary text-white'
            : 'd-flex align-items-center justify-content-center rounded mr-75 border text-secondary'"
        >
          3
        </div>
        <span :class="isCouriersActive ? 'font-weight-bolder text-primary' : 'font-weight-bolder'">Kurir</span>
      </button>
    </component>

    <!-- Pickup -->
    <component :is="brandId ? 'RouterLink' : 'div'" :to="brandId && `/v2/brands/${brandId}/pickup`">
      <button class="btn btn-white d-flex align-items-center py-50 pl-0" :disabled="!brandId">
        <div
          style="width: 36px; height: 36px;"
          :class="isPickupActive
            ? 'd-flex align-items-center justify-content-center rounded mr-75 bg-primary text-white'
            : 'd-flex align-items-center justify-content-center rounded mr-75 border text-secondary'"
        >
          4
        </div>
        <span :class="isPickupActive ? 'font-weight-bolder text-primary' : 'font-weight-bolder'">Pickup</span>
      </button>
    </component>
  </div>
</template>

<script>
export default {
  name: 'BrandWizardNavigation',
  props: {
    brandId: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    profileTo() {
      return this.brandId ? `/v2/brands/${this.brandId}/edit` : '/v2/brands/create'
    },
    currentRoute() {
      return this.$route.name
    },
    isProfileActive() {
      return ['brands-v2-create', 'brands-v2-edit'].includes(this.currentRoute)
    },
    isAddressActive() {
      return this.currentRoute === 'brands-v2-address'
    },
    isCouriersActive() {
      return this.currentRoute === 'brands-v2-couriers'
    },
    isPickupActive() {
      return this.currentRoute === 'brands-v2-pickup'
    },
  },
}
</script>
